import { createSlice } from '@reduxjs/toolkit'

export const clusterSlice = createSlice({
  name: 'clusters',
  initialState: {
    clusters: [],
    sortModel: [],
    notificationSettings: []
  },
  reducers: {
    setClusters: (state, action) => {
        state.clusters = action.payload
    },
    updateCluster: (state, action) => {
        const { clusterName , fieldName, fieldValue } = action.payload
        const cluster = state.clusters.find(cluster => cluster.clusterName === clusterName)
        if (cluster) {
            const impose = {}
            impose[fieldName] = fieldValue
            Object.assign(cluster, impose)
        }
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload
    },
    setNotificationSettings: (state, action) => {
      state.notificationSettings = action.payload
    },
    updateNotificationSetting: (state, action) => {
      const { cluster, field, value } = action.payload
      const setting = state.notificationSettings.find(s => s.cluster === cluster)
      if (setting) {
        setting[field] = value
      }
    }
  },
})

// Action creators are generated for each case reducer function
export const { setClusters, setSortModel, updateCluster, setNotificationSettings, updateNotificationSetting } = clusterSlice.actions

export default clusterSlice.reducer
